export var IErrorReasonCode;
(function (IErrorReasonCode) {
    IErrorReasonCode["INVALID_UPC"] = "UPC must have a length of 13 characters";
    IErrorReasonCode["INVALID_PARAMETERS"] = "Cannot parse parameters";
    IErrorReasonCode["ACCESS_DENIED"] = "missing required scopes";
    IErrorReasonCode["CART_NOT_FULFILLABLE"] = "cart not fulfillable";
})(IErrorReasonCode || (IErrorReasonCode = {}));
